import * as React from 'react'

type FormPageLayoutProps = React.PropsWithChildren & {
    imageSrc?: string
    videoSrc?: string
}

export const FormPageLayout: React.FC<FormPageLayoutProps> = (props) => {
    const { children, imageSrc, videoSrc } = props
    const mediaClassName = 'absolute w-full h-full inset-0 object-cover'

    return (
        <div className="relative h-full lg:flex">
            <div className="relative z-20 flex h-full items-center justify-center p-6 lg:grow lg:bg-neutral-50">
                <div className="grid grid-cols-[minmax(0,auto)] justify-center">
                    {children}
                </div>
            </div>
            {(videoSrc || imageSrc) && (
                <div className="relative max-lg:absolute max-lg:inset-0 lg:basis-1/2">
                    {videoSrc && (
                        <video
                            className={mediaClassName}
                            src="assets/login.mp4"
                            autoPlay
                            muted
                            loop
                        />
                    )}
                    {imageSrc && <div className={mediaClassName} />}
                </div>
            )}
        </div>
    )
}
